import moment from "@/date";
import { TableColumnInterface } from "@/common/types";
import { WorkExperienceInterface } from "../types";

const userColumn: TableColumnInterface = {
  title: "User",
  dataIndex: "user.name",
  key: "user",
  width: 180,
  scopedSlots: { customRender: "user" },
};

const titleColumn: TableColumnInterface = {
  title: "Title",
  dataIndex: "title",
  key: "work-experience",
};

const companyColumn: TableColumnInterface = {
  title: "Company",
  dataIndex: "company_name",
  key: "company_name",
};

const startDateColumn: TableColumnInterface = {
  title: "Start date",
  dataIndex: "start_date",
  key: "start_date",
  width: 120,
  sorter: (a: WorkExperienceInterface, b: WorkExperienceInterface) =>
    +moment(a.start_date || undefined) - +moment(b.start_date || undefined),
};

const endDateColumn: TableColumnInterface = {
  title: "End date",
  dataIndex: "end_date",
  key: "end_date",
  width: 120,
  sorter: (a: WorkExperienceInterface, b: WorkExperienceInterface) =>
    +moment(a.end_date || undefined) - +moment(b.end_date || undefined),
};

export const workExperiencesColumns: Array<TableColumnInterface> = [
  userColumn,
  titleColumn,
  companyColumn,
  startDateColumn,
  endDateColumn,
];

export const myWorkExperiencesColumns: Array<TableColumnInterface> = [
  titleColumn,
  companyColumn,
  startDateColumn,
  endDateColumn,
];
